export default __webpack_public_path__ + "static/media/easyfmm_logo.8c0726f5.png";